import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-refer-product',
  templateUrl: './refer-product.component.html',
  styleUrls: ['./refer-product.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReferProductComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
